import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-scroll-guide',
  templateUrl: './scroll-guide.component.html',
  styleUrls: ['./scroll-guide.component.scss']
})

export class ScrollGuideComponent {
  @Input() conditions: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/common-theme/utils/scroll-guide/scroll-guide.component.ts